import { orderNumberFilterAtom } from 'atoms/filters/sim-products';
import { orderNumberHintsAtom } from 'atoms/hints/sim-products';
import { HintedTextFieldFilters } from 'common/components/Filters/Inputs/HintedTextFieldFilters';
import { useTranslation } from 'react-i18next';

export const OrderNumberSearchInput = () => {
  const { t } = useTranslation();

  return (
    <HintedTextFieldFilters
      data-testid="orderNumber text field"
      placeholder={t('simInventory.orderNumberFilterPlaceholder')}
      filterAtom={orderNumberFilterAtom}
      filterHintsAtom={orderNumberHintsAtom}
    />
  );
};
